export default __webpack_public_path__ + "static/media/dimg6.1d8ac504.jpg";